import { render, staticRenderFns } from "./CButtonGroup.vue?vue&type=template&id=2f35d5cf&scoped=true"
import script from "./CButtonGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./CButtonGroup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CButtonGroup.vue?vue&type=style&index=0&id=2f35d5cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f35d5cf",
  null
  
)

export default component.exports